import React from "react";
import { Waypoint } from "react-waypoint";
import Loading from "../../components/loading";

class InfiniteScrolling extends React.Component {
    state = {
        loading: false
    };

    onEnter = () => {
        if (!this.state.loading) {
            this.setState({ loading: true });
            this.props
                .loadMore()
                .then(this.onLoaded)
                .catch(this.onLoaded);
        }
    };

    onLoaded = () => {
        this.setState({ loading: false });
    };

    render() {
        return (
            <div>
                <div className="clearfix">{this.props.elements}</div>
                {this.state.loading ? <Loading /> : null}
                <Waypoint onEnter={this.onEnter} />
            </div>
        );
    }
}

export default InfiniteScrolling;
